import { Truck, Phone, MessageCircle, Mail } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL, EMAIL_1, EMAIL_2 } from "@/constants/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-800 bg-slate-950 py-14">
      <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 md:flex-row md:items-start md:justify-between">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-orange-500 text-white">
              <Truck className="h-5 w-5" />
            </span>
            <span className="font-display text-xl font-semibold text-white">Sgomberiamo</span>
          </div>
          <p className="mt-4 max-w-sm text-sm text-slate-400">
            Sgomberi di case, cantine, garage, uffici ed eredità. Preventivo gratuito,
            prezzo chiaro, anche in giornata.
          </p>
        </div>
        <div className="space-y-3" data-testid="footer-contacts">
          <p className="text-sm font-semibold uppercase tracking-widest text-slate-500">Contatti</p>
          <a href={PHONE_TEL} data-testid="footer-phone" className="flex items-center gap-2 text-slate-300 transition-colors duration-200 hover:text-orange-400">
            <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
          </a>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 text-slate-300 transition-colors duration-200 hover:text-green-400">
            <MessageCircle className="h-4 w-4" /> Scrivici su WhatsApp
          </a>
          <a href={`mailto:${EMAIL_1}`} data-testid="footer-email-1" className="flex items-center gap-2 text-slate-300 transition-colors duration-200 hover:text-orange-400">
            <Mail className="h-4 w-4" /> {EMAIL_1}
          </a>
          <a href={`mailto:${EMAIL_2}`} data-testid="footer-email-2" className="flex items-center gap-2 text-slate-300 transition-colors duration-200 hover:text-orange-400">
            <Mail className="h-4 w-4" /> {EMAIL_2}
          </a>
        </div>
        <div className="space-y-3">
          <p className="text-sm font-semibold uppercase tracking-widest text-slate-500">Servizi</p>
          <p className="text-sm text-slate-400">Case e appartamenti</p>
          <p className="text-sm text-slate-400">Cantine, solai e garage</p>
          <p className="text-sm text-slate-400">Eredità e lutti</p>
          <p className="text-sm text-slate-400">Uffici e aziende</p>
        </div>
      </div>
      <div className="mx-auto mt-12 max-w-7xl border-t border-slate-800 px-6 pt-6">
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} Sgomberiamo — Tutti i diritti riservati.</p>
      </div>
    </footer>
  );
}
